import { PageContentWrapper } from 'app/member/layouts/wrapper/page-content';
import React from 'react';

import ListPayment from './list/list';

const PaymentModule = () => {
  return (
    <PageContentWrapper>
      <ListPayment />
    </PageContentWrapper>
  );
};

export default PaymentModule;
